import * as React from "react";

const CloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="#5f6368"
    viewBox="0 -960 960 960"
  >
    <path d="M256-213.85 213.85-256l224-224-224-224L256-746.15l224 224 224-224L746.15-704l-224 224 224 224L704-213.85l-224-224z"></path>
  </svg>
);

export default CloseIcon;
